import WeaInput from "../wea-input";
import WeaTextarea from "../wea-textarea";
import WeaDateGroup from "../wea-date-group";
import WeaSelect from "../wea-select";
import WeaBrowser from "../wea-browser";
import WeaCheckbox from "../wea-checkbox";
import WeaSelectGroup from "../wea-select-group";
import WeaScope from "../wea-scope";
import WeaDatePicker from "../wea-date-picker";
import WeaTimePicker from "../wea-time-picker";
import WeaRangePicker from "../wea-range-picker";
import WeaTimeRangePicker from "../wea-time-range-picker";
import WeaLocaleProvider from "../wea-locale-provider";

import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import forEach from "lodash/forEach";

const getLabel = WeaLocaleProvider.getLabel;
const getBrowserValue = field => {
  if (!isEmpty(field.browserConditionParam)) {
    const replacesDatas =
      field.browserConditionParam.replaceDatas ||
      field.browserConditionParam.valueObj;
    if (!isEmpty(replacesDatas)) {
      let values = [],
        names = [];
      replacesDatas.forEach(d => {
        if (d) {
          values.push(d.id);
          names.push(d.lastname || d.name); // 人力按钮特殊处理
        }
      });
      return {
        value: values.join(","),
        valueSpan: names.join(","),
        valueObj: replacesDatas
      };
    }
  }
};

export function getModuleRender(modules = {}, key, content, context) {
  const module = modules[key];
  if (module) {
    if (typeof module === "function") {
      content = module(context);
    }
    content = module;
  }
  return content;
}

export function getSelectDefaultValue(options, type) {
  let value = "";
  if (type == 5) {
    forEach(options, o => {
      o.options &&
        forEach(o.options, option => {
          if (option.selected) value = option.key;
        });
    });
  } else {
    // 获取单选和多选的初始值
    const arr = [];
    forEach(options, option => {
      if (option.selected) {
        arr.push(option.key);
      }
    });
    value = arr.join(",");
  }
  return value;
}

export function getComponent(
  conditionType = "input",
  browserConditionParam,
  domkey,
  props,
  field,
  hasUnderline = false
) {
  let ct = conditionType.toUpperCase();
  const { getFieldProps, setFieldsValue } = props.form;
  if (ct == "RANGEPICKER") {
    return (
      <WeaRangePicker
        ecId={`${props.ecId}_WeaRangePicker@bfgswf`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "TIMERANGEPICKER") {
    return (
      <WeaTimeRangePicker
        ecId={`${props.ecId}_WeaTimeRangePicker@qw3tb8`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "INPUT") {
    return (
      <WeaInput
        ecId={`${props.ecId}_WeaInput@f69azh`}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        {...field.otherParams}
        length={field.length}
        viewAttr={field.viewAttr}
        hasBorder={!hasUnderline}
        underline={hasUnderline}
      />
    );
  }
  if (ct == "TEXTAREA") {
    return (
      <WeaTextarea
        ecId={`${props.ecId}_WeaTextarea@mxfafu`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        length={field.length}
        minRows={field.minRows ? field.minRows : 2}
        maxRows={field.maxRows}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "SELECT") {
    return (
      <WeaSelect
        ecId={`${props.ecId}_WeaSelect@9hp0z3`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], {
          initialValue: getSelectDefaultValue(field.options)
        })}
        detailtype={field.detailtype || 1}
        options={field.options}
        viewAttr={field.viewAttr}
        hasBorder={!hasUnderline}
        underline={hasUnderline}
        onChange={value => {
          let nState = {};
          nState[`${domkey[0]}`] = value;
          setFieldsValue(nState);
        }}
      />
    );
  }
  if (ct == "BROWSER") {
    const showDropMenu =
      browserConditionParam.type == "4" || browserConditionParam.type == "164"; // 部门分部显示维度菜单
    let v = "";
    let res = getBrowserValue(field);
    if (res && res.value) v = res.value;
    const otherParams = browserConditionParam
      ? browserConditionParam.otherParams
      : {};
    return (
      <WeaBrowser
        ecId={`${props.ecId}_WeaBrowser@8jgtt1`}
        {...field.otherParams}
        isAdSearch
        hasBorder={!hasUnderline}
        underline={hasUnderline}
        {...browserConditionParam}
        {...otherParams}
        replaceNotCtrl={true} // 浏览按钮高级搜索里面的浏览按钮特殊处理
        showDropMenu={showDropMenu}
        {...getFieldProps(domkey[0], {
          initialValue: v
        })}
        onChange={(value, valueSpan, valueObj) => {
          let nState = {};
          nState[`${domkey[0]}`] = value;
          setFieldsValue(nState, valueSpan, valueObj);
        }}
      />
    );
  }
  if (ct == "DATE") {
    let value = "0";
    if (!isEmpty(field.value)) {
      value = field.value[domkey[0]];
    }
    let datas = [
      { value: "0", name: getLabel(332, "全部") },
      { value: "1", name: getLabel(15537, "今天") },
      { value: "2", name: getLabel(15539, "本周") },
      { value: "3", name: getLabel(15541, "本月") },
      { value: "4", name: getLabel(21904, "本季") },
      { value: "5", name: getLabel(15384, "本年") },
      { value: "7", name: getLabel(27347, "上个月") },
      { value: "8", name: getLabel(81716, "上一年") },
      { value: "6", name: getLabel(32530, "指定日期范围") }
    ];
    if (!isEmpty(field.options)) {
      datas = [];
      field.options.forEach(o => {
        datas.push({
          value: o.key,
          name: o.showname
        });
      });
    }
    return (
      <WeaDateGroup
        ecId={`${props.ecId}_WeaDateGroup@e5kqa6`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: value })}
        datas={datas}
        form={props.form}
        values={field.value}
        domkey={domkey}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "CHECKBOX") {
    return (
      <WeaCheckbox
        ecId={`${props.ecId}_WeaCheckbox@1duxce`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "SWITCH") {
    return (
      <WeaCheckbox
        ecId={`${props.ecId}_WeaCheckbox@wf4qql`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        viewAttr={field.viewAttr}
        display="switch"
      />
    );
  }
  if (ct == "SELECT_LINKAGE") {
    return (
      <WeaSelectGroup
        ecId={`${props.ecId}_WeaSelectGroup@2ptte8`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], {
          initialValue: getSelectDefaultValue(field.options)
        })}
        selectWidth={field.selectWidth}
        options={field.options}
        selectLinkageDatas={field.selectLinkageDatas}
        form={props.form}
        domkey={domkey}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "SCOPE") {
    return (
      <WeaScope
        ecId={`${props.ecId}_WeaScope@07426r`}
        step={field.step}
        {...field.otherParams}
        {...getFieldProps(domkey[0])}
        startValue={field.startValue}
        endValue={field.endValue}
        min={field.min}
        max={field.max}
        form={props.form}
        domkey={domkey}
        viewAttr={field.viewAttr}
      />
    );
  }
  if (ct == "DATEPICKER") {
    return (
      <WeaDatePicker
        ecId={`${props.ecId}_WeaDatePicker@4rtn76`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        formatPattern={field.formatPattern || 2}
        viewAttr={field.viewAttr}
        hasBorder={!hasUnderline}
        underline={hasUnderline}
      />
    );
  }
  if (ct == "TIMEPICKER") {
    return (
      <WeaTimePicker
        ecId={`${props.ecId}_WeaTimePicker@5k8o3p`}
        {...field.otherParams}
        {...getFieldProps(domkey[0], { initialValue: field.value })}
        formatPattern={field.formatPattern || 3}
        viewAttr={field.viewAttr}
        hasBorder={!hasUnderline}
        underline={hasUnderline}
      />
    );
  }
}

export function getParamsByConditions(conditions) {
  let params = {};
  !isEmpty(conditions) &&
    conditions.forEach(c => {
      const conditionType = c.conditionType;
      if (conditionType == "INPUT") {
        if (c.value) params[c.domkey[0]] = c.value;
      }
      if (conditionType == "SELECT") {
        let value = getSelectDefaultValue(c.options);
        if (value) params[c.domkey[0]] = value;
      }
      if (conditionType == "BROWSER") {
        if (!isEmpty(c.browserConditionParam)) {
          const replacesDatas = c.browserConditionParam.replaceDatas;
          let values = [],
            value;
          !isEmpty(replacesDatas) &&
            replacesDatas.forEach(d => {
              values.push(d.id);
            });
          value = values.join(",");
          if (value) params[c.domkey[0]] = value;
        }
      }
      if (conditionType == "DATE") {
        if (!isEmpty(c.value) && isArray(c.domkey) && isObject(c.value)) {
          c.domkey.forEach(d => {
            if (c.value[d]) {
              params[d] = c.value[d];
            }
          });
        }
      }
      if (conditionType === "SELECT_LINKAGE") {
        let selectValue = getSelectDefaultValue(c.options);
        params[c.domkey[0]] = selectValue;
        if (c.selectLinkageDatas) {
          let sld = c.selectLinkageDatas[selectValue];
          sld = sld ? [sld] : [];
          params = Object.assign(params, getParamsByConditions(sld));
        }
      }
      if (conditionType == "SCOPE") {
        if (c.startValue !== undefined) params[c.domkey[0]] = c.startValue;
        if (c.endValue !== undefined) params[c.domkey[1]] = c.endValue;
      }
      if (
        conditionType == "TIMERANGEPICKER" ||
        conditionType == "RANGEPICKER"
      ) {
        if (c.value && Array.isArray(c.value)) {
          params[c.domkey[0]] = c.value;
        }
      }
    });
  return params;
}



// WEBPACK FOOTER //
// ./ecology9/wea-tools/getComponent.js